import Column from '@app/components/layout/Column'
import { EventCard } from '@app/components/blocks/event/EventCard'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'

export const Events = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const translations = useTranslations().app
  return (
    <Column>
      <Title.H4>{translations.serviceProviderPage.events}</Title.H4>

      {serviceProvider.events &&
        serviceProvider.events.map((event) => (
          <EventCard key={event.uuid} title={event.title} start={event.start} />
        ))}
    </Column>
  )
}
